import _asyncToGenerator from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { captureException, getCurrentHub, addGlobalEventProcessor, setContext } from '@sentry/core';
import { logger, addInstrumentationHandler } from '@sentry/utils';
import './node_modules/rrweb/es/rrweb/packages/rrweb/src/entries/all.js';
import { SESSION_IDLE_DURATION, WINDOW, VISIBILITY_CHANGE_TIMEOUT, MAX_SESSION_LIFE, REPLAY_EVENT_NAME, UNABLE_TO_SEND_REPLAY } from './constants.js';
import { breadcrumbHandler } from './coreHandlers/breadcrumbHandler.js';
import { handleFetchSpanListener } from './coreHandlers/handleFetch.js';
import { handleGlobalEventListener } from './coreHandlers/handleGlobalEvent.js';
import { handleHistorySpanListener } from './coreHandlers/handleHistory.js';
import { handleXhrSpanListener } from './coreHandlers/handleXhr.js';
import { setupPerformanceObserver } from './coreHandlers/performanceObserver.js';
import { createPerformanceEntries } from './createPerformanceEntry.js';
import { createEventBuffer } from './eventBuffer.js';
import { deleteSession } from './session/deleteSession.js';
import { getSession } from './session/getSession.js';
import { saveSession } from './session/saveSession.js';
import { addEvent } from './util/addEvent.js';
import { addMemoryEntry } from './util/addMemoryEntry.js';
import { createBreadcrumb } from './util/createBreadcrumb.js';
import { createPayload } from './util/createPayload.js';
import { createPerformanceSpans } from './util/createPerformanceSpans.js';
import { createReplayEnvelope } from './util/createReplayEnvelope.js';
import { debounce } from './util/debounce.js';
import { getReplayEvent } from './util/getReplayEvent.js';
import { isExpired } from './util/isExpired.js';
import { isSessionExpired } from './util/isSessionExpired.js';
import { overwriteRecordDroppedEvent, restoreRecordDroppedEvent } from './util/monkeyPatchRecordDroppedEvent.js';
import record from './node_modules/rrweb/es/rrweb/packages/rrweb/src/record/index.js';
import { EventType } from './node_modules/rrweb/es/rrweb/packages/rrweb/src/types.js';
/* eslint-disable max-lines */
// TODO: We might want to split this file up

/**
 * Returns true to return control to calling function, otherwise continue with normal batching
 */

var BASE_RETRY_INTERVAL = 5000;
var MAX_RETRY_COUNT = 3;

var ReplayContainer = /*#__PURE__*/function () {
  function ReplayContainer(_ref) {
    var _this = this;

    var options = _ref.options,
        recordingOptions = _ref.recordingOptions;

    _classCallCheck(this, ReplayContainer);

    ;

    ReplayContainer.prototype.__init.call(this);

    ReplayContainer.prototype.__init2.call(this);

    ReplayContainer.prototype.__init3.call(this);

    ReplayContainer.prototype.__init4.call(this);

    ReplayContainer.prototype.__init5.call(this);

    ReplayContainer.prototype.__init6.call(this);

    ReplayContainer.prototype.__init7.call(this);

    ReplayContainer.prototype.__init8.call(this);

    ReplayContainer.prototype.__init9.call(this);

    ReplayContainer.prototype.__init10.call(this);

    ReplayContainer.prototype.__init11.call(this);

    ReplayContainer.prototype.__init12.call(this);

    ReplayContainer.prototype.__init13.call(this);

    ReplayContainer.prototype.__init14.call(this);

    ReplayContainer.prototype.__init15.call(this);

    ReplayContainer.prototype.__init16.call(this);

    ReplayContainer.prototype.__init17.call(this);

    ReplayContainer.prototype.__init18.call(this);

    ReplayContainer.prototype.__init19.call(this);

    this._recordingOptions = recordingOptions;
    this._options = options;
    this._debouncedFlush = debounce(function () {
      return _this.flush();
    }, this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    });
  }
  /** Get the event context. */


  _createClass(ReplayContainer, [{
    key: "__init",
    value: function __init() {
      this.eventBuffer = null;
    }
    /**
     * List of PerformanceEntry from PerformanceObserver
     */

  }, {
    key: "__init2",
    value: function __init2() {
      this.performanceEvents = [];
    }
    /**
     * Recording can happen in one of two modes:
     * * session: Record the whole session, sending it continuously
     * * error: Always keep the last 60s of recording, and when an error occurs, send it immediately
     */

  }, {
    key: "__init3",
    value: function __init3() {
      this.recordingMode = 'session';
    }
    /**
     * Options to pass to `rrweb.record()`
     */

  }, {
    key: "__init4",
    value: function __init4() {
      this._performanceObserver = null;
    }
  }, {
    key: "__init5",
    value: function __init5() {
      this._retryCount = 0;
    }
  }, {
    key: "__init6",
    value: function __init6() {
      this._retryInterval = BASE_RETRY_INTERVAL;
    }
  }, {
    key: "__init7",
    value: function __init7() {
      this._flushLock = null;
    }
    /**
     * Timestamp of the last user activity. This lives across sessions.
     */

  }, {
    key: "__init8",
    value: function __init8() {
      this._lastActivity = new Date().getTime();
    }
    /**
     * Is the integration currently active?
     */

  }, {
    key: "__init9",
    value: function __init9() {
      this._isEnabled = false;
    }
    /**
     * Paused is a state where:
     * - DOM Recording is not listening at all
     * - Nothing will be added to event buffer (e.g. core SDK events)
     */

  }, {
    key: "__init10",
    value: function __init10() {
      this._isPaused = false;
    }
    /**
     * Have we attached listeners to the core SDK?
     * Note we have to track this as there is no way to remove instrumentation handlers.
     */

  }, {
    key: "__init11",
    value: function __init11() {
      this._hasInitializedCoreListeners = false;
    }
    /**
     * Function to stop recording
     */

  }, {
    key: "__init12",
    value: function __init12() {
      this._stopRecording = null;
    }
  }, {
    key: "__init13",
    value: function __init13() {
      this._context = {
        errorIds: new Set(),
        traceIds: new Set(),
        urls: [],
        earliestEvent: null,
        initialTimestamp: new Date().getTime(),
        initialUrl: ''
      };
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
    /** If recording is currently enabled. */

  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this._isEnabled;
    }
    /** If recording is currently paused. */

  }, {
    key: "isPaused",
    value: function isPaused() {
      return this._isPaused;
    }
    /** Get the replay integration options. */

  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }
    /**
     * Initializes the plugin.
     *
     * Creates or loads a session, attaches listeners to varying events (DOM,
     * _performanceObserver, Recording, Sentry SDK, etc)
     */

  }, {
    key: "start",
    value: function start() {
      this.setInitialState();
      this.loadSession({
        expiry: SESSION_IDLE_DURATION
      }); // If there is no session, then something bad has happened - can't continue

      if (!this.session) {
        this.handleException(new Error('No session found'));
        return;
      }

      if (!this.session.sampled) {
        // If session was not sampled, then we do not initialize the integration at all.
        return;
      } // Modify recording options to checkoutEveryNthSecond if
      // sampling for error replay. This is because we don't know
      // when an error will occur, so we need to keep a buffer of
      // replay events.


      if (this.session.sampled === 'error') {
        this.recordingMode = 'error';
      } // setup() is generally called on page load or manually - in both cases we
      // should treat it as an activity


      this.updateSessionActivity();
      this.eventBuffer = createEventBuffer({
        useCompression: Boolean(this._options.useCompression)
      });
      this.addListeners(); // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout

      this._isEnabled = true;
      this.startRecording();
    }
    /**
     * Start recording.
     *
     * Note that this will cause a new DOM checkout
     */

  }, {
    key: "startRecording",
    value: function startRecording() {
      try {
        this._stopRecording = record(_objectSpread(_objectSpread(_objectSpread({}, this._recordingOptions), this.recordingMode === 'error' && {
          checkoutEveryNth: 60000
        }), {}, {
          emit: this.handleRecordingEmit
        }));
      } catch (err) {
        this.handleException(err);
      }
    }
    /**
     * Stops the recording, if it was running.
     * Returns true if it was stopped, else false.
     */

  }, {
    key: "stopRecording",
    value: function stopRecording() {
      if (this._stopRecording) {
        this._stopRecording();

        return true;
      }

      return false;
    }
    /**
     * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
     * does not support a teardown
     */

  }, {
    key: "stop",
    value: function stop() {
      try {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Stopping Replays');
        this._isEnabled = false;
        this.removeListeners();

        _optionalChain([this, 'access', function (_8) {
          return _8._stopRecording;
        }, 'optionalCall', function (_9) {
          return _9();
        }]);

        _optionalChain([this, 'access', function (_10) {
          return _10.eventBuffer;
        }, 'optionalAccess', function (_11) {
          return _11.destroy;
        }, 'call', function (_12) {
          return _12();
        }]);

        this.eventBuffer = null;
      } catch (err) {
        this.handleException(err);
      }
    }
    /**
     * Pause some replay functionality. See comments for `_isPaused`.
     * This differs from stop as this only stops DOM recording, it is
     * not as thorough of a shutdown as `stop()`.
     */

  }, {
    key: "pause",
    value: function pause() {
      this._isPaused = true;

      try {
        if (this._stopRecording) {
          this._stopRecording();

          this._stopRecording = undefined;
        }
      } catch (err) {
        this.handleException(err);
      }
    }
    /**
     * Resumes recording, see notes for `pause().
     *
     * Note that calling `startRecording()` here will cause a
     * new DOM checkout.`
     */

  }, {
    key: "resume",
    value: function resume() {
      this._isPaused = false;
      this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */

  }, {
    key: "handleException",
    value: function handleException(error) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay]', error);

      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) {
        captureException(error);
      }
    }
    /** for tests only */

  }, {
    key: "clearSession",
    value: function clearSession() {
      try {
        deleteSession();
        this.session = undefined;
      } catch (err) {
        this.handleException(err);
      }
    }
    /**
     * Loads a session from storage, or creates a new one if it does not exist or
     * is expired.
     */

  }, {
    key: "loadSession",
    value: function loadSession(_ref2) {
      var expiry = _ref2.expiry;

      var _getSession = getSession({
        expiry: expiry,
        stickySession: Boolean(this._options.stickySession),
        currentSession: this.session,
        sessionSampleRate: this._options.sessionSampleRate,
        errorSampleRate: this._options.errorSampleRate
      }),
          type = _getSession.type,
          session = _getSession.session; // If session was newly created (i.e. was not loaded from storage), then
      // enable flag to create the root replay


      if (type === 'new') {
        this.setInitialState();
      }

      if (session.id !== _optionalChain([this, 'access', function (_13) {
        return _13.session;
      }, 'optionalAccess', function (_14) {
        return _14.id;
      }])) {
        session.previousSessionId = _optionalChain([this, 'access', function (_15) {
          return _15.session;
        }, 'optionalAccess', function (_16) {
          return _16.id;
        }]);
      }

      this.session = session;
    }
    /**
     * Capture some initial state that can change throughout the lifespan of the
     * replay. This is required because otherwise they would be captured at the
     * first flush.
     */

  }, {
    key: "setInitialState",
    value: function setInitialState() {
      var urlPath = "".concat(WINDOW.location.pathname).concat(WINDOW.location.hash).concat(WINDOW.location.search);
      var url = "".concat(WINDOW.location.origin).concat(urlPath);
      this.performanceEvents = []; // Reset _context as well

      this.clearContext();
      this._context.initialUrl = url;
      this._context.initialTimestamp = new Date().getTime();

      this._context.urls.push(url);
    }
    /**
     * Adds listeners to record events for the replay
     */

  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this2 = this;

      try {
        WINDOW.document.addEventListener('visibilitychange', this.handleVisibilityChange);
        WINDOW.addEventListener('blur', this.handleWindowBlur);
        WINDOW.addEventListener('focus', this.handleWindowFocus); // We need to filter out dropped events captured by `addGlobalEventProcessor(this.handleGlobalEvent)` below

        overwriteRecordDroppedEvent(this._context.errorIds); // There is no way to remove these listeners, so ensure they are only added once

        if (!this._hasInitializedCoreListeners) {
          // Listeners from core SDK //
          var scope = getCurrentHub().getScope();

          _optionalChain([scope, 'optionalAccess', function (_17) {
            return _17.addScopeListener;
          }, 'call', function (_18) {
            return _18(_this2.handleCoreBreadcrumbListener('scope'));
          }]);

          addInstrumentationHandler('dom', this.handleCoreBreadcrumbListener('dom'));
          addInstrumentationHandler('fetch', handleFetchSpanListener(this));
          addInstrumentationHandler('xhr', handleXhrSpanListener(this));
          addInstrumentationHandler('history', handleHistorySpanListener(this)); // Tag all (non replay) events that get sent to Sentry with the current
          // replay ID so that we can reference them later in the UI

          addGlobalEventProcessor(handleGlobalEventListener(this));
          this._hasInitializedCoreListeners = true;
        }
      } catch (err) {
        this.handleException(err);
      } // _performanceObserver //


      if (!('_performanceObserver' in WINDOW)) {
        return;
      }

      this._performanceObserver = setupPerformanceObserver(this);
    }
    /**
     * Cleans up listeners that were created in `addListeners`
     */

  }, {
    key: "removeListeners",
    value: function removeListeners() {
      try {
        WINDOW.document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        WINDOW.removeEventListener('blur', this.handleWindowBlur);
        WINDOW.removeEventListener('focus', this.handleWindowFocus);
        restoreRecordDroppedEvent();

        if (this._performanceObserver) {
          this._performanceObserver.disconnect();

          this._performanceObserver = null;
        }
      } catch (err) {
        this.handleException(err);
      }
    }
    /**
     * We want to batch uploads of replay events. Save events only if
     * `<flushMinDelay>` milliseconds have elapsed since the last event
     * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
     *
     * Accepts a callback to perform side-effects and returns true to stop batch
     * processing and hand back control to caller.
     */

  }, {
    key: "addUpdate",
    value: function addUpdate(cb) {
      // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'error'`)
      var cbResult = _optionalChain([cb, 'optionalCall', function (_19) {
        return _19();
      }]); // If this option is turned on then we will only want to call `flush`
      // explicitly


      if (this.recordingMode === 'error') {
        return;
      } // If callback is true, we do not want to continue with flushing -- the
      // caller will need to handle it.


      if (cbResult === true) {
        return;
      } // addUpdate is called quite frequently - use _debouncedFlush so that it
      // respects the flush delays and does not flush immediately


      this._debouncedFlush();
    }
    /**
     * Handler for recording events.
     *
     * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
     */

  }, {
    key: "__init14",
    value: function __init14() {
      var _this3 = this;

      this.handleRecordingEmit = function (event, isCheckout) {
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!_this3.checkAndHandleExpiredSession()) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay] Received replay event after session expired.');
          return;
        }

        _this3.addUpdate(function () {
          // The session is always started immediately on pageload/init, but for
          // error-only replays, it should reflect the most recent checkout
          // when an error occurs. Clear any state that happens before this current
          // checkout. This needs to happen before `addEvent()` which updates state
          // dependent on this reset.
          if (_this3.recordingMode === 'error' && event.type === 2) {
            _this3.setInitialState();
          } // We need to clear existing events on a checkout, otherwise they are
          // incremental event updates and should be appended


          addEvent(_this3, event, isCheckout); // Different behavior for full snapshots (type=2), ignore other event types
          // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16

          if (event.type !== 2) {
            return false;
          } // If there is a previousSessionId after a full snapshot occurs, then
          // the replay session was started due to session expiration. The new session
          // is started before triggering a new checkout and contains the id
          // of the previous session. Do not immediately flush in this case
          // to avoid capturing only the checkout and instead the replay will
          // be captured if they perform any follow-up actions.


          if (_optionalChain([_this3, 'access', function (_20) {
            return _20.session;
          }, 'optionalAccess', function (_21) {
            return _21.previousSessionId;
          }])) {
            return true;
          } // See note above re: session start needs to reflect the most recent
          // checkout.


          if (_this3.recordingMode === 'error' && _this3.session && _this3._context.earliestEvent) {
            _this3.session.started = _this3._context.earliestEvent;

            _this3._maybeSaveSession();
          } // Flush immediately so that we do not miss the first segment, otherwise
          // it can prevent loading on the UI. This will cause an increase in short
          // replays (e.g. opening and closing a tab quickly), but these can be
          // filtered on the UI.


          if (_this3.recordingMode === 'session') {
            void _this3.flushImmediate();
          }

          return true;
        });
      };
    }
    /**
     * Handle when visibility of the page content changes. Opening a new tab will
     * cause the state to change to hidden because of content of current page will
     * be hidden. Likewise, moving a different window to cover the contents of the
     * page will also trigger a change to a hidden state.
     */

  }, {
    key: "__init15",
    value: function __init15() {
      var _this4 = this;

      this.handleVisibilityChange = function () {
        if (WINDOW.document.visibilityState === 'visible') {
          _this4.doChangeToForegroundTasks();
        } else {
          _this4.doChangeToBackgroundTasks();
        }
      };
    }
    /**
     * Handle when page is blurred
     */

  }, {
    key: "__init16",
    value: function __init16() {
      var _this5 = this;

      this.handleWindowBlur = function () {
        var breadcrumb = createBreadcrumb({
          category: 'ui.blur'
        }); // Do not count blur as a user action -- it's part of the process of them
        // leaving the page

        _this5.doChangeToBackgroundTasks(breadcrumb);
      };
    }
    /**
     * Handle when page is focused
     */

  }, {
    key: "__init17",
    value: function __init17() {
      var _this6 = this;

      this.handleWindowFocus = function () {
        var breadcrumb = createBreadcrumb({
          category: 'ui.focus'
        }); // Do not count focus as a user action -- instead wait until they focus and
        // interactive with page

        _this6.doChangeToForegroundTasks(breadcrumb);
      };
    }
    /**
     * Handler for Sentry Core SDK events.
     *
     * These events will create breadcrumb-like objects in the recording.
     */

  }, {
    key: "__init18",
    value: function __init18() {
      var _this7 = this;

      this.handleCoreBreadcrumbListener = function (type) {
        return function (handlerData) {
          if (!_this7._isEnabled) {
            return;
          }

          var result = breadcrumbHandler(type, handlerData);

          if (result === null) {
            return;
          }

          if (result.category === 'sentry.transaction') {
            return;
          }

          if (result.category === 'ui.click') {
            _this7.triggerUserActivity();
          } else {
            _this7.checkAndHandleExpiredSession();
          }

          _this7.addUpdate(function () {
            addEvent(_this7, {
              type: EventType.Custom,
              // TODO: We were converting from ms to seconds for breadcrumbs, spans,
              // but maybe we should just keep them as milliseconds
              timestamp: (result.timestamp || 0) * 1000,
              data: {
                tag: 'breadcrumb',
                payload: result
              }
            }); // Do not flush after console log messages

            return result.category === 'console';
          });
        };
      };
    }
    /**
     * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
     */

  }, {
    key: "doChangeToBackgroundTasks",
    value: function doChangeToBackgroundTasks(breadcrumb) {
      if (!this.session) {
        return;
      }

      var expired = isSessionExpired(this.session, VISIBILITY_CHANGE_TIMEOUT);

      if (breadcrumb && !expired) {
        this.createCustomBreadcrumb(breadcrumb);
      } // Send replay when the page/tab becomes hidden. There is no reason to send
      // replay if it becomes visible, since no actions we care about were done
      // while it was hidden


      this.conditionalFlush();
    }
    /**
     * Tasks to run when we consider a page to be visible (via focus and/or visibility)
     */

  }, {
    key: "doChangeToForegroundTasks",
    value: function doChangeToForegroundTasks(breadcrumb) {
      if (!this.session) {
        return;
      }

      var isSessionActive = this.checkAndHandleExpiredSession({
        expiry: VISIBILITY_CHANGE_TIMEOUT
      });

      if (!isSessionActive) {
        // If the user has come back to the page within VISIBILITY_CHANGE_TIMEOUT
        // ms, we will re-use the existing session, otherwise create a new
        // session
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Document has become active, but session has expired');
        return;
      }

      if (breadcrumb) {
        this.createCustomBreadcrumb(breadcrumb);
      }
    }
    /**
     * Trigger rrweb to take a full snapshot which will cause this plugin to
     * create a new Replay event.
     */

  }, {
    key: "triggerFullSnapshot",
    value: function triggerFullSnapshot() {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Replay] Taking full rrweb snapshot');
      record.takeFullSnapshot(true);
    }
    /**
     * Update user activity (across session lifespans)
     */

  }, {
    key: "updateUserActivity",
    value: function updateUserActivity() {
      var _lastActivity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();

      this._lastActivity = _lastActivity;
    }
    /**
     * Updates the session's last activity timestamp
     */

  }, {
    key: "updateSessionActivity",
    value: function updateSessionActivity() {
      var _lastActivity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();

      if (this.session) {
        this.session.lastActivity = _lastActivity;

        this._maybeSaveSession();
      }
    }
    /**
     * Updates the user activity timestamp and resumes recording. This should be
     * called in an event handler for a user action that we consider as the user
     * being "active" (e.g. a mouse click).
     */

  }, {
    key: "triggerUserActivity",
    value: function triggerUserActivity() {
      this.updateUserActivity(); // This case means that recording was once stopped due to inactivity.
      // Ensure that recording is resumed.

      if (!this._stopRecording) {
        // Create a new session, otherwise when the user action is flushed, it
        // will get rejected due to an expired session.
        this.loadSession({
          expiry: SESSION_IDLE_DURATION
        }); // Note: This will cause a new DOM checkout

        this.resume();
        return;
      } // Otherwise... recording was never suspended, continue as normalish


      this.checkAndHandleExpiredSession();
      this.updateSessionActivity();
    }
    /**
     * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
     */

  }, {
    key: "createCustomBreadcrumb",
    value: function createCustomBreadcrumb(breadcrumb) {
      var _this8 = this;

      this.addUpdate(function () {
        addEvent(_this8, {
          type: EventType.Custom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb
          }
        });
      });
    }
    /**
     * Observed performance events are added to `this.performanceEvents`. These
     * are included in the replay event before it is finished and sent to Sentry.
     */

  }, {
    key: "addPerformanceEntries",
    value: function addPerformanceEntries() {
      // Copy and reset entries before processing
      var entries = _toConsumableArray(this.performanceEvents);

      this.performanceEvents = [];
      createPerformanceSpans(this, createPerformanceEntries(entries));
    }
    /**
     * Checks if recording should be stopped due to user inactivity. Otherwise
     * check if session is expired and create a new session if so. Triggers a new
     * full snapshot on new session.
     *
     * Returns true if session is not expired, false otherwise.
     */

  }, {
    key: "checkAndHandleExpiredSession",
    value: function checkAndHandleExpiredSession() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$expiry = _ref3.expiry,
          expiry = _ref3$expiry === void 0 ? SESSION_IDLE_DURATION : _ref3$expiry;

      var oldSessionId = _optionalChain([this, 'access', function (_22) {
        return _22.session;
      }, 'optionalAccess', function (_23) {
        return _23.id;
      }]); // Prevent starting a new session if the last user activity is older than
      // MAX_SESSION_LIFE. Otherwise non-user activity can trigger a new
      // session+recording. This creates noisy replays that do not have much
      // content in them.


      if (this._lastActivity && isExpired(this._lastActivity, MAX_SESSION_LIFE)) {
        // Pause recording
        this.pause();
        return;
      } // --- There is recent user activity --- //
      // This will create a new session if expired, based on expiry length


      this.loadSession({
        expiry: expiry
      }); // Session was expired if session ids do not match

      var expired = oldSessionId !== _optionalChain([this, 'access', function (_24) {
        return _24.session;
      }, 'optionalAccess', function (_25) {
        return _25.id;
      }]);

      if (!expired) {
        return true;
      } // Session is expired, trigger a full snapshot (which will create a new session)


      this.triggerFullSnapshot();
      return false;
    }
    /**
     * Only flush if `this.recordingMode === 'session'`
     */

  }, {
    key: "conditionalFlush",
    value: function conditionalFlush() {
      if (this.recordingMode === 'error') {
        return;
      }

      void this.flushImmediate();
    }
    /**
     * Clear _context
     */

  }, {
    key: "clearContext",
    value: function clearContext() {
      // XXX: `initialTimestamp` and `initialUrl` do not get cleared
      this._context.errorIds.clear();

      this._context.traceIds.clear();

      this._context.urls = [];
      this._context.earliestEvent = null;
    }
    /**
     * Return and clear _context
     */

  }, {
    key: "popEventContext",
    value: function popEventContext() {
      if (this._context.earliestEvent && this._context.earliestEvent < this._context.initialTimestamp) {
        this._context.initialTimestamp = this._context.earliestEvent;
      }

      var _context = {
        initialTimestamp: this._context.initialTimestamp,
        initialUrl: this._context.initialUrl,
        errorIds: Array.from(this._context.errorIds).filter(Boolean),
        traceIds: Array.from(this._context.traceIds).filter(Boolean),
        urls: this._context.urls
      };
      this.clearContext();
      return _context;
    }
    /**
     * Flushes replay event buffer to Sentry.
     *
     * Performance events are only added right before flushing - this is
     * due to the buffered performance observer events.
     *
     * Should never be called directly, only by `flush`
     */

  }, {
    key: "runFlush",
    value: function () {
      var _runFlush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var recordingData, replayId, eventContext, segmentId;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.session) {
                  _context2.next = 3;
                  break;
                }

                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay] No session found to flush.');
                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return this.addPerformanceEntries();

              case 5:
                if (_optionalChain([this, 'access', function (_26) {
                  return _26.eventBuffer;
                }, 'optionalAccess', function (_27) {
                  return _27.length;
                }])) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                _context2.next = 9;
                return addMemoryEntry(this);

              case 9:
                _context2.prev = 9;
                _context2.next = 12;
                return this.eventBuffer.finish();

              case 12:
                recordingData = _context2.sent;
                // NOTE: Copy values from instance members, as it's possible they could
                // change before the flush finishes.
                replayId = this.session.id;
                eventContext = this.popEventContext(); // Always increment segmentId regardless of outcome of sending replay

                segmentId = this.session.segmentId++;

                this._maybeSaveSession();

                _context2.next = 19;
                return this.sendReplay({
                  replayId: replayId,
                  events: recordingData,
                  segmentId: segmentId,
                  includeReplayStartTimestamp: segmentId === 0,
                  eventContext: eventContext
                });

              case 19:
                _context2.next = 24;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](9);
                this.handleException(_context2.t0);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this, [[9, 21]]);
      }));

      function runFlush() {
        return _runFlush.apply(this, arguments);
      }

      return runFlush;
    }()
    /**
     * Flush recording data to Sentry. Creates a lock so that only a single flush
     * can be active at a time. Do not call this directly.
     */

  }, {
    key: "__init19",
    value: function __init19() {
      var _this9 = this;

      this.flush = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this9._isEnabled) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (_this9.checkAndHandleExpiredSession()) {
                  _context3.next = 5;
                  break;
                }

                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay] Attempting to finish replay event after session expired.');
                return _context3.abrupt("return");

              case 5:
                if (_optionalChain([_this9, 'access', function (_28) {
                  return _28.session;
                }, 'optionalAccess', function (_29) {
                  return _29.id;
                }])) {
                  _context3.next = 8;
                  break;
                }

                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('[Replay] No session found to flush.');
                return _context3.abrupt("return");

              case 8:
                // A flush is about to happen, cancel any queued flushes
                _optionalChain([_this9, 'access', function (_30) {
                  return _30._debouncedFlush;
                }, 'optionalAccess', function (_31) {
                  return _31.cancel;
                }, 'call', function (_32) {
                  return _32();
                }]); // this._flushLock acts as a lock so that future calls to `flush()`
                // will be blocked until this promise resolves


                if (_this9._flushLock) {
                  _context3.next = 15;
                  break;
                }

                _this9._flushLock = _this9.runFlush();
                _context3.next = 13;
                return _this9._flushLock;

              case 13:
                _this9._flushLock = null;
                return _context3.abrupt("return");

              case 15:
                _context3.prev = 15;
                _context3.next = 18;
                return _this9._flushLock;

              case 18:
                _context3.next = 23;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](15);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error(_context3.t0);

              case 23:
                _context3.prev = 23;

                _this9._debouncedFlush();

                return _context3.finish(23);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, null, [[15, 20, 23, 26]]);
      }));
    }
    /**
     *
     * Always flush via `_debouncedFlush` so that we do not have flushes triggered
     * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
     * cases of mulitple flushes happening closely together.
     */

  }, {
    key: "flushImmediate",
    value: function flushImmediate() {
      this._debouncedFlush(); // `.flush` is provided by the debounced function, analogously to lodash.debounce


      return this._debouncedFlush.flush();
    }
    /**
     * Send replay attachment using `fetch()`
     */

  }, {
    key: "sendReplayRequest",
    value: function () {
      var _sendReplayRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
        var events, replayId, segment_id, includeReplayStartTimestamp, eventContext, payloadWithSequence, urls, errorIds, traceIds, initialTimestamp, currentTimestamp, hub, client, scope, transport, dsn, baseEvent, replayEvent, envelope;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                events = _ref5.events, replayId = _ref5.replayId, segment_id = _ref5.segmentId, includeReplayStartTimestamp = _ref5.includeReplayStartTimestamp, eventContext = _ref5.eventContext;
                payloadWithSequence = createPayload({
                  events: events,
                  headers: {
                    segment_id: segment_id
                  }
                });
                urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, initialTimestamp = eventContext.initialTimestamp;
                currentTimestamp = new Date().getTime();
                hub = getCurrentHub();
                client = hub.getClient();
                scope = hub.getScope();
                transport = client && client.getTransport();
                dsn = _optionalChain([client, 'optionalAccess', function (_33) {
                  return _33.getDsn;
                }, 'call', function (_34) {
                  return _34();
                }]);

                if (!(!client || !scope || !transport || !dsn)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                baseEvent = _objectSpread(_objectSpread({
                  // @ts-ignore private api
                  type: REPLAY_EVENT_NAME
                }, includeReplayStartTimestamp ? {
                  replay_start_timestamp: initialTimestamp / 1000
                } : {}), {}, {
                  timestamp: currentTimestamp / 1000,
                  error_ids: errorIds,
                  trace_ids: traceIds,
                  urls: urls,
                  replay_id: replayId,
                  segment_id: segment_id
                });
                _context4.next = 14;
                return getReplayEvent({
                  scope: scope,
                  client: client,
                  replayId: replayId,
                  event: baseEvent
                });

              case 14:
                replayEvent = _context4.sent;

                if (replayEvent) {
                  _context4.next = 19;
                  break;
                }

                // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
                client.recordDroppedEvent('event_processor', 'replay_event', baseEvent);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('An event processor returned `null`, will not send event.');
                return _context4.abrupt("return");

              case 19:
                replayEvent.tags = _objectSpread(_objectSpread({}, replayEvent.tags), {}, {
                  sessionSampleRate: this._options.sessionSampleRate,
                  errorSampleRate: this._options.errorSampleRate,
                  replayType: _optionalChain([this, 'access', function (_35) {
                    return _35.session;
                  }, 'optionalAccess', function (_36) {
                    return _36.sampled;
                  }])
                });
                /*
                For reference, the fully built event looks something like this:
                {
                    "type": "replay_event",
                    "timestamp": 1670837008.634,
                    "error_ids": [
                        "errorId"
                    ],
                    "trace_ids": [
                        "traceId"
                    ],
                    "urls": [
                        "https://example.com"
                    ],
                    "replay_id": "eventId",
                    "segment_id": 3,
                    "platform": "javascript",
                    "event_id": "eventId",
                    "environment": "production",
                    "sdk": {
                        "integrations": [
                            "BrowserTracing",
                            "Replay"
                        ],
                        "name": "sentry.javascript.browser",
                        "version": "7.25.0"
                    },
                    "sdkProcessingMetadata": {},
                    "tags": {
                        "sessionSampleRate": 1,
                        "errorSampleRate": 0,
                        "replayType": "error"
                    }
                }
                */

                envelope = createReplayEnvelope(replayEvent, payloadWithSequence, dsn, client.getOptions().tunnel);
                _context4.prev = 21;
                _context4.next = 24;
                return transport.send(envelope);

              case 24:
                return _context4.abrupt("return", _context4.sent);

              case 27:
                _context4.prev = 27;
                _context4.t0 = _context4["catch"](21);
                throw new Error(UNABLE_TO_SEND_REPLAY);

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this, [[21, 27]]);
      }));

      function sendReplayRequest(_x) {
        return _sendReplayRequest.apply(this, arguments);
      }

      return sendReplayRequest;
    }()
  }, {
    key: "resetRetries",
    value: function resetRetries() {
      this._retryCount = 0;
      this._retryInterval = BASE_RETRY_INTERVAL;
    }
    /**
     * Finalize and send the current replay event to Sentry
     */

  }, {
    key: "sendReplay",
    value: function () {
      var _sendReplay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
        var _this10 = this;

        var replayId, events, segmentId, includeReplayStartTimestamp, eventContext;
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                replayId = _ref6.replayId, events = _ref6.events, segmentId = _ref6.segmentId, includeReplayStartTimestamp = _ref6.includeReplayStartTimestamp, eventContext = _ref6.eventContext;

                if (events.length) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                _context6.prev = 3;
                _context6.next = 6;
                return this.sendReplayRequest({
                  events: events,
                  replayId: replayId,
                  segmentId: segmentId,
                  includeReplayStartTimestamp: includeReplayStartTimestamp,
                  eventContext: eventContext
                });

              case 6:
                this.resetRetries();
                return _context6.abrupt("return", true);

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](3);
                // Capture error for every failed replay
                setContext('Replays', {
                  _retryCount: this._retryCount
                });
                this.handleException(_context6.t0); // If an error happened here, it's likely that uploading the attachment
                // failed, we'll can retry with the same events payload

                if (!(this._retryCount >= MAX_RETRY_COUNT)) {
                  _context6.next = 16;
                  break;
                }

                throw new Error("".concat(UNABLE_TO_SEND_REPLAY, " - max retries exceeded"));

              case 16:
                this._retryCount = this._retryCount + 1; // will retry in intervals of 5, 10, 30

                this._retryInterval = this._retryCount * this._retryInterval;
                _context6.next = 20;
                return new Promise(function (resolve, reject) {
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return _this10.sendReplay({
                              replayId: replayId,
                              events: events,
                              segmentId: segmentId,
                              includeReplayStartTimestamp: includeReplayStartTimestamp,
                              eventContext: eventContext
                            });

                          case 3:
                            resolve(true);
                            _context5.next = 9;
                            break;

                          case 6:
                            _context5.prev = 6;
                            _context5.t0 = _context5["catch"](0);
                            reject(_context5.t0);

                          case 9:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee4, null, [[0, 6]]);
                  })), _this10._retryInterval);
                });

              case 20:
                return _context6.abrupt("return", _context6.sent);

              case 21:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this, [[3, 10]]);
      }));

      function sendReplay(_x2) {
        return _sendReplay.apply(this, arguments);
      }

      return sendReplay;
    }()
    /** Save the session, if it is sticky */

  }, {
    key: "_maybeSaveSession",
    value: function _maybeSaveSession() {
      if (this.session && this._options.stickySession) {
        saveSession(this.session);
      }
    }
  }]);

  return ReplayContainer;
}();

export { ReplayContainer };